import PropTypes from "prop-types";
import React from "react";

import { Badge } from "@swa-ui/core";

import { getUrgencyTriggerTheme } from "./getUrgencyTriggerTheme";

/**
 * component that uses Badge component to display an urgency-trigger badge on promotional banners
 */

export const UrgencyTriggerBadge = (props) => {
  const { endDate, startDate, themeName, urgencyTriggerOverride } = props.commandProps || {};
  const theme = getUrgencyTriggerTheme(endDate, startDate, themeName, urgencyTriggerOverride);

  return theme.label && <Badge {...getBadgeProps()}></Badge>;

  function getBadgeProps() {
    return {
      border: { color: "transparent", radius: "medium" },
      children: theme.label.toString(),
      label: theme.label,
      padding: theme.size,
      styleType: theme.styleType,
    };
  }
};

UrgencyTriggerBadge.propTypes = {
  children: PropTypes.node,

  /** command props from WCM (set as not required if WCM decides not to send commandProps) */
  commandProps: PropTypes.shape({
    /** endDate indicates promotion's ending date */
    endDate: PropTypes.string,
    /** label indicates the badge label */
    label: PropTypes.string,
    /** startDate indicates promotion's starting date */
    startDate: PropTypes.string,
    /** themeName indicates specific theme in data.js */
    themeName: PropTypes.string,
    /** urgencyTriggerOverride indicates specific data override by business */
    urgencyTriggerOverride: PropTypes.array,
  }),
};
